import { Language } from 'apps/agora/src/TranslationContext';
import ParentPageSessionFeedbackModal from '../ParentPageSessionFeedbackModal/ParentPageSessionFeedbackModal';

interface ParentPageEnrollmentFeedbackModalProps {
  sessionId: string;
  onClose: () => void;
  language: Language;
}

const ParentPageEnrollmentFeedbackModal = (props: ParentPageEnrollmentFeedbackModalProps) => {
  const { sessionId, onClose, language } = props;

  return (
    <ParentPageSessionFeedbackModal sessionId={sessionId} onClose={onClose} language={language} />
  );
};

export default ParentPageEnrollmentFeedbackModal;
